import { useState } from "react";
import { Check, Copy } from "lucide-react";

export function CopyReviewUrlButton({
  url,
  className = "",
}: {
  url: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);

  async function onClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    await navigator.clipboard.writeText(url);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1200);
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1 rounded-md px-1.5 py-1 text-xs font-medium text-slate-500 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-100 ${className}`}
      aria-label="Copy Amazon review URL"
      title="Copy Amazon review URL"
    >
      {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      <span>{copied ? "Copied" : "Copy URL"}</span>
    </button>
  );
}
